(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/export', {
      templateUrl: 'modules/app/data/export/export.html',
      controller: 'ExportCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('ExportCtrl', ['$scope', 'PersonUtils', 'QueryES', 'User', 'UserRoles', function ($scope, PersonUtils, QueryES, User, UserRoles) {
    $scope.section = 'export';
    $scope.exportFormat = 'json';
    $scope.isAdmin = UserRoles.isOrgAdmin(User.get()) || UserRoles.isSystemAdmin(User.get());

    //filter results by user if not Admin
    var isCsv = false,
      filters = {},
      user = User.get();
    $scope.isAdmin = UserRoles.isOrgAdmin(user) || UserRoles.isSystemAdmin(user);
    if (!$scope.isAdmin) {
      PersonUtils.getUserPersonId().then(function (response) {
        filters = {
          personIds: [response]
        };
        $scope.downloadUrl = QueryES.queryExportUrl(filters, isCsv);
      });
    } else {
      $scope.downloadUrl = QueryES.queryExportUrl(filters, isCsv);
    }
    $scope.updateDownloadUrl = function updateDownloadUrl(newValue) {
      $scope.exportFormat = newValue;
      isCsv = $scope.exportFormat === "csv";
      $scope.downloadUrl = QueryES.queryExportUrl(filters, isCsv);
    };
  }]).controller('OutboundDataSourcesCtrl', ['$scope', '$http', 'Api', 'Logger', 'Utils', 'User', function ($scope, $http, Api, Logger, Utils, User) {
    var statementPipeUrl;
    if (!$scope.isAdmin) {
      statementPipeUrl = Api.url("/users/" + User.get().user.id + "/statement-pipes");
    } else {
      statementPipeUrl = Api.url("/statement-pipes");
    }
    $http.get(statementPipeUrl).then(function fetchStatementPipesSuccess(response) {
      $scope.outboundDataSources = response.data.results.filter(function (pipe) {
        return pipe.pipeType === "push";
      });
    }, function fetchStatementPipesError(response) {
      Logger.error("Statement Pipes fetch failed with response status " + response.status);
      $scope.error = "There was an error fetching the statement pipes.";
    });
    $scope.createNewOutboundDataSource = function createNewOutboundDataSource() {
      var newOutboundDataSource = {
        "organization": {
          "id": User.get().organization.id
        },
        "name": "",
        "id": null,
        "pipeType": "push",
        "targetUrl": "",
        "targetUsername": "",
        "targetPW": "",
        "sourceUrl": Utils.qualifyURL(Api.url("/lrs/statements")),
        "sourceUsername": "INSERTED-SERVERSIDE",
        "sourcePW": "INSERTED-SERVERSIDE",
        "statementCount": 0
      };
      if (!$scope.isAdmin) {
        newOutboundDataSource.user = {
          "id": User.get().user.id
        };
      }
      newOutboundDataSource.isNew = true;
      $scope.outboundDataSources.push(newOutboundDataSource);
    };
    $scope.$on("outbound-statementpipe-delete", function outboundStmtPipeDelete(evt, index) {
      $scope.outboundDataSources = Utils.removeAt($scope.outboundDataSources, index);
    });
  }]).controller('OutboundDataSourceItemCtrl', ['$scope', '$http', '$uibModal', 'Api', 'Logger', 'Utils', 'Validation', function ($scope, $http, $uibModal, Api, Logger, Utils, Validation) {
    function validateForm(scope) {
      return Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": scope.editCopy.name
        },
        "targetUrl": {
          "display": "Endpoint URL",
          "rules": {
            "required": true,
            "url": true
          },
          "value": scope.editCopy.targetUrl
        },
        "targetUsername": {
          "display": "Key",
          "rules": {
            "required": true
          },
          "value": scope.editCopy.targetUsername
        },
        "targetPW": {
          "display": "Secret",
          "rules": {
            "required": false
          },
          "value": scope.editCopy.targetPW
        }
      });
    }
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.ds); // ds variable is from the ng-repeat iterator
      $scope.saving = false;
      $scope.editing = false;
      $scope.editingSecret = true;
      $scope.formErrors = null;
      $scope.saveError = null;
    }
    resetEditingState();

    // Newly added rows will have a "new" property which we use to immediately show the editing view
    if ($scope.ds.isNew === true) {
      $scope.editing = $scope.editingSecret = true;
      delete $scope.ds.isNew;
    }
    $scope.save = function save() {
      $scope.formErrors = validateForm($scope);
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $scope.saveError = null;
      if ($scope.editCopy.id === null) {
        $http.post(Api.url("/statement-pipes", true), $scope.editCopy).then(function createDataSourceSuccess(response) {
          $scope.ds = $scope.editCopy;
          $scope.ds.id = Utils.getIdFromCreatedResponse(response);
          $scope.ds.isNew = null;
          resetEditingState();
        }, function createDataSourceError(response) {
          Logger.error("Create statement pipe failed with response status " + response.status);
          $scope.saveError = response.data.message;
          $scope.saving = false;
        });
      } else {
        $http.put(Api.url("/statement-pipes/" + $scope.ds.id, true), $scope.editCopy).then(function statementPipeUpdateSuccess() {
          $scope.ds = $scope.editCopy;
          resetEditingState();
        }, function statementPipeUpdateFail(response) {
          Logger.error("Update statement pipe failed with response status " + response.status);
          $scope.saveError = response.data.message;
          $scope.saving = false;
        });
      }
    };
    $scope.cancel = function cancel() {
      // If it was a new (never saved) pipe and you cancel, remove the row from the UI
      if ($scope.ds.id === null) {
        $scope.$emit("outbound-statementpipe-delete", $scope.$index);
      }
      resetEditingState();
    };
    $scope.remove = function remove() {
      $scope.deleteError = null;
      $http['delete'](Api.url("/statement-pipes/" + $scope.ds.id, true)).then(function deleteStatementPipeSuccess() {
        $scope.$emit("outbound-statementpipe-delete", $scope.$index);
      }, function deleteStatementPipeError(response) {
        Logger.error("An error occurred deleting statement pipe with id " + $scope.ds.id + "." + "Failed with status " + response.status);
        $scope.deleteError = "There was error in deleting the statement pipe.";
      });
    };
    $scope.showErrors = function showErrors() {
      $uibModal.open({
        controller: "StatementPipeErrorModalCtrl",
        templateUrl: 'modules/app/data/xapi/statement-pipe-error-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          statementPipe: function statementPipe() {
            return $scope.ds;
          }
        }
      });
    };
  }]);
})();
